// src/pages/UserServicesReport.js
import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { fetchUserServicesReport, fetchUserDetails } from '../services/apiService';
import menuItemsByService from '../categories/serviceMenus';
import { useSidebar } from '../context/SidebarContext';

const UserServicesReport = () => {
  const { authTokens, impersonatedUserId } = useContext(AuthContext);
  const [userServices, setUserServices] = useState([]);
  const { isSidebarOpen } = useSidebar();
  const [availableServices, setAvailableServices] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      const data = await fetchUserServicesReport(authTokens);
      setUserServices(data);
    };

    loadData();
  }, [authTokens]);

  useEffect(() => {
    const loadUserServices = async () => {
      if (authTokens && (impersonatedUserId || authTokens.userRole !== 'admin')) {
        try {
          const userIdToFetch = impersonatedUserId || authTokens.userId;
          const userDetails = await fetchUserDetails(userIdToFetch, authTokens);
          const serviceOrder = {
            'Anexo 30 y 31 2022': 1,
            'Anexo 30 y 31 2023': 2,
            'Anexo 30 y 31 2024': 3,
            'Anexo 30 y 31 2025': 4,
            'Dictamen de Diseño': 5,
            'NOM-016-CRE-2016': 6,
            'Anexo 30 y 31 para transporte o distribución': 7,
          };
          const sortedServices = userDetails.services.sort(
            (a, b) => (serviceOrder[a.name] || 0) - (serviceOrder[b.name] || 0),
          );
          setAvailableServices(sortedServices);
        } catch (error) {
          console.error('Error al cargar los servicios del usuario:', error);
        }
      }
    };

    loadUserServices();
  }, [authTokens, impersonatedUserId]);

  if (!authTokens) {
    return <div>Cargando...</div>;
  }

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar */}
      <div
        className={`fixed md:fixed top-16 left-0 h-[calc(100vh-4rem)] overflow-y-auto transform
          ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
          transition duration-200 ease-in-out
          w-64 bg-white shadow-lg z-40`}
      >
        <div className="p-8 border-b">
          <img src="/images/logo2.png" alt="Logo Petrotec" className="h-32 w-auto mx-auto" />
        </div>
        <nav className="mt-6">
          <Link
            to="/dashboard"
            className={`
              block px-4 py-3 hover:bg-blue-50 transition-colors duration-200
              text-gray-700 hover:text-blue-600 border-b border-gray-100
            `}
          >
            Inicio
          </Link>
          <div className="px-4 py-2">
            <h2 className="text-xs uppercase font-semibold text-gray-600 tracking-wide">
              Servicios Disponibles
            </h2>
          </div>
          {availableServices.map((service) => {
            const firstMenuItem = menuItemsByService[service.name]?.[0];
            return (
              <Link
                key={service.id}
                to={firstMenuItem?.path || '#'}
                className="block px-4 py-3 hover:bg-blue-50 transition-colors duration-200 text-gray-700 hover:text-blue-600"
              >
                {service.name}
              </Link>
            );
          })}
        </nav>
      </div>

      {/* Main Content */}
      <div className={`flex-1 transition-all duration-200 ${isSidebarOpen ? 'md:ml-64' : ''}`}>

        <div className="p-8 h-[calc(100vh-4rem)]">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-gray-900">Reporte de Altas de Servicios</h1>
            <p className="mt-2 text-gray-600">
              Visualiza el historial de servicios dados de alta en el sistema.
            </p>
          </div>

          <div className="bg-white shadow-lg rounded-lg overflow-hidden h-[calc(100%-7rem)]">
            <div className="overflow-y-auto h-full scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50 sticky top-0">
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Fecha de Alta
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Usuario
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Servicio
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {userServices.map((userService) => (
                    <tr
                      key={userService.id}
                      className="hover:bg-gray-50 transition-colors duration-200"
                    >
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {new Date(userService.created_at).toLocaleDateString()}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {userService.user.username}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {userService.service.name}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserServicesReport;
